module.exports = __webpack_public_path__ + "img/accounting.4cf2598d.svg";